export const tabs = [
  { label: "Organization Information", value: "general", rolesDisallowed: ["super-client"] },
  {
    label: "Organization Directory",
    value: "users",
    rolesAllowed: ["client-admin"],
    rolesDisallowed: ["super-client"]
  },
  { label: 'Brands', value: 'brands', rolesDisallowed: ["super-client"] },
  { label: 'Select Different Client', value: 'switch', rolesAllowed: ["super-client"] },
];

export const hotKey = {
  keyBlur: "`",
};

export const viewList = [
  { label: "USERS LIST", value: "users" },
  { label: "ROLES LIST", value: "roles" },
];

export const userActions = [
  { label: "Edit User", value: "edit" },
  { label: "Reset Password", value: "reset" },
  { label: "Remove User", value: "remove" },
];

export const addUserFields = [
  { label: "Name", name: "nickname", length: 100 },
  { label: "Phone Number", name: "phone" },
  {
    label: "Role",
    name: "scope",
    options: [
      { label: "Admin", value: "client-admin" },
      { label: "Team member", value: "client" },
      { label: "View only", value: "client-read-only" },
    ],
  },
  { label: "Email", name: "email" },
  { label: "Username", name: "username", disabled: true },
];

export const userGroupHeaders = [
  { name: "role", label: "Role", highlight: true },
  { name: "role_type", label: "Role Type" },
  { name: "access", label: "Access" },
  { name: "count", label: "No of users" },
  { name: "actions", label: "" },
];

export const userGroupListHeaders = [
  { name: "_scopes", label: "Role", highlight: true },
  { name: "id", label: "User ID" },
  { name: "info.nickname", label: "Name" },
  { name: "phone", label: "Phone No." },
  { name: "email", label: "Email" },
];

export const resetPasswordFields = [
  { label: "New Password", name: "password" },
  { label: "Confirm New Password", name: "password2" },
];

export const userDetail = [
  { label: "ID", name: "id" },
  { label: "Name", name: "info.nickname" },
  { label: "Email", name: "email" },
  { label: "Phone Number", name: "phone" },
  { label: "Role", name: "_scopes" },
  { label: "Username", name: "username", size: 12 },
];

export const generatePasswordTypes = [
  {
    label: "Use auto-generated password",
    value: "auto",
    hint: "(Password is automatically sent to user’s registered email)",
  },
  { label: "Set new password manually", value: "manual" },
];
